import styled from 'styled-components';
import { textEllipsis } from '../../../../../../../common/styles/Layout';
import { ThemeColours } from '../../../../../../../common/styles/ThemeColours';

export const Collapsing = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  min-width: 0;
`;

export const Value = styled.div`
  color: ${ThemeColours.mono700};
  font-size: 14px;
  ${textEllipsis};
`;

export const More = styled.div`
  color: ${ThemeColours.mono600};
  flex-shrink: 0;
  font-size: 12px;
  margin-inline-start: 4px;
`;
